import { Form, Input, Button } from "antd";

export default function TotpForm({ onSubmitCode }) {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    onSubmitCode(values);
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Form.Item
        name="code"
        rules={[
          { required: true, message: "Ingresa el código" },
          { len: 6, message: "Debe tener 6 dígitos" }
        ]}
      >
        <Input
          placeholder="Código TOTP"
          maxLength={6}
          style={{ textAlign: "center", fontSize: "20px" }}
        />
      </Form.Item>

      <Button type="primary" htmlType="submit" block>
        Verificar
      </Button>
    </Form>
  );
}